import { componentInterface } from '@ardoq/component-interface';

const isParentChildReferenceModelId = (modelId: string) => {
  if (!modelId.includes('-')) return false;
  const [parentId, childId] = modelId.split('-');
  return componentInterface.getParentId(childId) === parentId;
};
export { isParentChildReferenceModelId };
